import React, { Component } from 'react';
import { connect } from 'react-redux';
import { publishActions } from '../actions/publishActions';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '../lib/ckeditor';
import LatextEditor from './latexEditor';
import MathJax from 'react-mathjax-preview';

export class EditQuestion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formFields: {
                subject: '',
                exam: '',
                slug: '',
                title: '',
                questionText: '',
                answerText: '',
                isReviewed: '',
                isQuestionFieldDirty: false,
                isAnswerFieldDirty: false,
                isTitleFielddirty: false,
                isSlugFielddirty: false,
                isDescriptionFieldDirty: false
            },
        },
            this.newSlugValue = '';
        this.redirectToQuesTable = this.redirectToQuesTable.bind(this);
        this.updateQuestionData = this.updateQuestionData.bind(this);
        this.fetchSolutionText = this.fetchSolutionText.bind(this);
        this.updateNewSlugValue = this.updateNewSlugValue.bind(this);
        this.insertAtCaret = this.insertAtCaret.bind(this);
        this.fetchQuesText = this.fetchQuesText.bind(this);
        //this.insertEquation = this.insertEquation.bind(this);
        this.symbols = ["=", "≠", "≈",
            ">",
            "<",
            "≥",
            "≤",
            "()",
            "[]",
            "+",
            "-",
            "±",
            "∓",
            "*",
            "×",
            "⋅",
            "÷",
            "/",
            "mod",
            "^",
            "√a",
            "%",
            "∠",
            "⊥",
            "∥",
            "≅",
            "~",
            "Δ",
            "|x-y|",
            "π",
            "{ }",
            "⌊x⌋",
            "⌈x⌉",
            "|x|",
            "x!",
            "f(x)",
            "(f∘g)",
            "∑",
            "⋂",
            "⋃",
            "μ",
            "σ",
            "χ",
            "⊆",
            "⊂",
            "⊄",
            "⊇",
            "⊃",
            "⊅",
            "",
            "⊖",
            "∈",
            "∉",
            "Ø",
            "x'",
            "∫",
            "∫∫",
            "∫∫∫",
            "∮",
            "∇",
            "x²",
            "x⁴"
        ];
    }

    updateQuestionData() {
        const oldQuesData = this.props.currentQuestion;
        const newQuesData = this.state.formFields;

        const oldSlugValue = oldQuesData.slug ? oldQuesData.slug.replace(new RegExp(`-?${oldQuesData.uid}`), '') : '';

        const questionData = {
            id: oldQuesData._id,
            solutionId: oldQuesData.solutionId,
            uid: oldQuesData.uid,
            isReviewed: newQuesData.isReviewed,
            subject: {
                lastValue: oldQuesData.subjectId,
                newValue: (newQuesData.subject || oldQuesData.subjectId)
            },
            exam: {
                lastValue: oldQuesData.examId,
                newValue: (newQuesData.exam || oldQuesData.examId)
            },
            slug: {
                lastValue: oldSlugValue,
                newValue: (this.newSlugValue || oldSlugValue)
            },
            answerText: {
                lastValue: oldQuesData.answerText,
                newValue: (newQuesData.answerText || oldQuesData.answerText)
            },
            questionText: {
                lastValue: oldQuesData.eng_text,
                newValue: (newQuesData.questionText || oldQuesData.eng_text)
            },
            title: {
                lastValue: oldQuesData.title,
                newValue: (newQuesData.title || oldQuesData.title)
            },
            description: {
                lastValue: oldQuesData.description,
                newValue: (newQuesData.description || oldQuesData.description)
            }
        }

        this.props.updateQuestion(questionData, this.props.selectedFilter);
        this.redirectToQuesTable();
    }

    redirectToQuesTable() {
        this.props.handleEditQuestionForm();
    }
    updateNewSlugValue(val) {
        if (val) {
            val = val.replace(new RegExp(`-?${this.props.currentQuestion.uid}`), '');
            val = val.replace(/[^\w-0-9]/gi, '');
            val = val.toLowerCase();
        }
        this.newSlugValue = val;
        return val;
    }

    inputHandler(e, editor = null, fieldName = '', dirtyFieldName = '') {
        let formFields = this.state.formFields;
        const currentFieldname = fieldName || e.target.name;
        formFields[currentFieldname] = editor ? editor.getData() : e.target.value;
        if (currentFieldname == 'slug') {
            formFields[currentFieldname] = this.updateNewSlugValue(e.target.value)
        }

        this.setState({
            formFields,
            [dirtyFieldName]: true
        });
    }
    checkboxHandler(e) {
        let formFields = this.state.formFields;
        formFields[e.target.name] = e.target.checked;

        this.setState({
            formFields,
        });
    }

    fetchSolutionText(e) {
        this.props.fetchSolutionText(this.props.currentQuestion.solution_url, (response) => {
            if (response.text) {
                this.setState({
                    formFields: {
                        ...this.state.formFields,
                        answerText: `${response.text.replace(/\n/g, '<br/>')}`,
                        isAnswerFieldDirty: true
                    }
                })
            } else {
                alert("No text found!")
            }
        });
    }
    fetchQuesText(e){
        this.props.fetchSolutionText(this.props.currentQuestion.crop_url, (response) => {
            if (response.text) {
                this.setState({
                    formFields: {
                        ...this.state.formFields,
                        questionText: `${response.text.replace(/\n/g, '<br/>')}`,
                        isQuestionFieldDirty: true
                    }
                })
            } else {
                alert("No text found!")
            }
        });
    }
    insertAtCaret(event, selector) {
        // const selector = "div.qe .ck-editor__main p";
        const text = event.target.innerText;
        const el = document.querySelector(selector);
        if (!el) {
            return;
        }

        el.value += text;
        el.innerText += text;
    }
    render() {
        const { filters } = this.props;
        return (
            <div className="editQuestionForm">
                <h3>Edit Question: {this.props.currentQuestion._id}</h3>
                <div className="form-group">
                    <label className="col-form-label">Subject</label>
                    <select className="form-control" name="subject" onChange={(e) => this.inputHandler.call(this, e)} value={this.state.formFields.subject || this.props.currentQuestion.subjectId || ''}>
                        <option value="">Select Subject</option>
                        {filters.subjects.map((sub, index) => (
                            <option key={sub._id} value={sub._id}> {sub.name} </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label className="col-form-label">Exam</label>
                    <select className="form-control" name="exam" onChange={(e) => this.inputHandler.call(this, e)} value={this.state.formFields.exam || this.props.currentQuestion.examId || ''}>
                        <option value="">Select Exam</option>
                        {filters.exams.map((exam, index) => (
                            <option key={exam._id} value={exam._id}> {exam.name} </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label className="col-form-label">Slug</label>
                    <input type="text" className="form-control" maxLength="65" name="slug" onChange={(e) => this.inputHandler.call(this, e, null, 'slug', 'isSlugFielddirty')} value={this.state.isSlugFielddirty ? this.state.formFields.slug : this.updateNewSlugValue(this.props.currentQuestion.slug) || ''} />
                </div>
                <div className="form-group">
                    <label className="col-form-label">Title</label>
                    <br />
                    {this.symbols.map((symbol, index) => {
                        return <span className="btn" onClick={(e) => this.insertAtCaret.call(this, e, '#title')} key={index}>{symbol}</span>
                    })}
                    <input type="text" className="form-control" name="title" id="title" onChange={(e) => this.inputHandler.call(this, e, null, 'title', 'isTitleFielddirty')} value={this.state.isTitleFielddirty ? this.state.formFields.title : this.props.currentQuestion.title} />
                </div>
                <div className="form-group">
                    <label className="col-form-label">Meta Description</label>
                    <br />
                    {this.symbols.map((symbol, index) => {
                        return <span className="btn" onClick={(e) => this.insertAtCaret.call(this, e, '#description')} key={index}>{symbol}</span>
                    })}
                    <input type="text" className="form-control" id="description" maxLength="165" name="description" onChange={(e) => this.inputHandler.call(this, e, null, 'description', 'isDescriptionFielddirty')} value={this.state.isDescriptionFielddirty ? this.state.formFields.description : this.props.currentQuestion.description} />
                </div>
                <div className="form-group">
                    <div className="row">
                        <label className="col-form-label">Question</label>
                        <br />
                        <img alt="" className="formImage" src={this.props.currentQuestion.crop_url} />
                        <a href={this.props.currentQuestion.crop_url} target="_blank">Open image in new tab</a>
                        <br /><br />
                        {this.symbols.map((symbol, index) => {
                            return <span className="btn" onClick={(e) => this.insertAtCaret.call(this, e, '#questionTextEditor')} key={index}>{symbol}</span>
                        })}
                        <hr />
                        <div className="col-md-6">
                            <div className="qe">
                                <textarea className="form-control" id="questionTextEditor" value={this.state.isQuestionFieldDirty ? this.state.formFields.questionText : this.props.currentQuestion.eng_text}
                                    onChange={(e, editor) => this.inputHandler.call(this, e, editor, 'questionText', 'isQuestionFieldDirty')}></textarea>
                                {/* <CKEditor
                                    id="questionTextEditor"
                                    data={this.state.isQuestionFieldDirty ? this.state.formFields.questionText : this.props.currentQuestion.eng_text}
                                    editor={ClassicEditor}
                                    onChange={(e, editor) => this.inputHandler.call(this, e, editor, 'questionText', 'isQuestionFieldDirty')}
                                    config={{
                                        ckfinder: {
                                            uploadUrl: `https://instasolv.com:3500/image?id=${this.props.currentQuestion._id}`
                                        }
                                    }}
                                /> */}
                            </div>
                            <LatextEditor parentSelector="#questionTextEditor" type="input"></LatextEditor>
                            <button type="button" className="btn btn-primary" data-url={this.props.currentQuestion.crop_url} onClick={this.fetchQuesText}>Extract Question Text</button>
                        </div>
                        <div className="col-md-6">
                            <MathJax config={{ messageStyle: 'none' }} math={this.state.isQuestionFieldDirty ? this.state.formFields.questionText : this.props.currentQuestion.eng_text} />
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <div className="row">
                        <label className="col-form-label">Answer</label>
                        <br />
                        <img alt="" className="formImage" src={this.props.currentQuestion.solution_url} />
                        <a href={this.props.currentQuestion.solution_url} target="_blank">Open image in new tab</a>
                        <br /><br />
                        {this.symbols.map((symbol, index) => {
                            return <span className="btn" onClick={(e) => this.insertAtCaret.call(this, e, 'div.ans .ck-editor__main p')} key={index}>{symbol}</span>
                        })}
                        <hr />
                        <div className="col-md-6">
                            <div className="ans">
                                <CKEditor
                                    id="answerTextEditor"
                                    data={this.state.formFields.isAnswerFieldDirty ? this.state.formFields.answerText : this.props.currentQuestion.answerText}
                                    editor={ClassicEditor}
                                    onChange={(e, editor) => this.inputHandler.call(this, e, editor, 'answerText', 'isAnswerFieldDirty')}
                                    config={{
                                        ckfinder: {
                                            uploadUrl: `https://instasolv.com:3500/image?id=${this.props.currentQuestion.solutionId}`
                                        }
                                    }}
                                />
                            </div>
                            <LatextEditor parentSelector="div.ans .ck-editor__main"></LatextEditor>&nbsp;&nbsp;
                            <button type="button" className="btn btn-primary" data-id={this.props.currentQuestion.solutionId} onClick={this.fetchSolutionText}>Extract Answer Text</button>
                        </div>
                        <div className="col-md-6">
                            <MathJax config={{ messageStyle: 'none' }} math={this.state.isAnswerFieldDirty ? this.state.formFields.answerText : this.props.currentQuestion.answerText} />
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <input type="checkbox" name="isReviewed" checked={typeof this.state.formFields.isReviewed == 'boolean' ? this.state.formFields.isReviewed : this.props.currentQuestion.isReviewed} onChange={(e) => this.checkboxHandler.call(this, e)} />
                    <label className="col-form-label">Is Reviewed</label>
                </div>
                <div className="form-group row">
                    <div className="col-sm-10">
                        <button type="button" onClick={this.redirectToQuesTable} className="btn btn-default">Back</button>
                        &nbsp;
                            <button type="button" onClick={this.updateQuestionData} className="btn btn-primary">Submit</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { selectedFilter, solutionText } = state.publish;
    return {
        selectedFilter,
        solutionText
    };
};

const actionCreators = { updateQuestion: publishActions.updateQuestion, fetchSolutionText: publishActions.fetchSolutionText }

export default connect(mapStateToProps, actionCreators)(EditQuestion);
